import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsJsonwebtokensComponent } from './simple-icons-jsonwebtokens.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsJsonwebtokensComponent ],
    exports:      [ SimpleIconsJsonwebtokensComponent ],
    bootstrap:    []
})
export class SimpleIconsJsonwebtokensModule {}
